<template>
	<div class="comp">
		<div class="compContent">
			<div class="content">
				<div class="con">
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:180px;margin-right: 10px;" placeholder="请输入顾客名称或手机号" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">创建门店</div>
							<el-select style="width:190px" class="select" v-model="search.shopId" placeholder="请选择" @change="changeSearch" size="small">
								<el-option v-for="item in shopsList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
								</el-option>
							</el-select>
							<div class="searchLabel">疫苗驱虫</div>
							<el-select style="width:130px" v-model="search.serviceTypeId" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:0},{label:'疫苗',value:1},{label:'驱虫',value:2}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="searchLabel">是否出库</div>
							<el-select style="width:130px" v-model="search.isEnter" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:0},{label:'已出库',value:1},{label:'未出库',value:2}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="searchLabel">是否支付</div>
							<el-select style="width:130px" v-model="search.isPay" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'已支付',value:1},{label:'未支付',value:0}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" prop="serviceId" min-width="110">
							</el-table-column>
							<el-table-column label="顾客" prop="memberName" min-width="70">
							</el-table-column>
							<el-table-column label="宠物昵称" prop="petName" min-width="80">
							</el-table-column>
							<el-table-column label="类别" min-width="50">
								<template slot-scope="props">
									<div v-if="props.row.serviceTypeId===1">疫苗</div>
									<div v-if="props.row.serviceTypeId===2">驱虫</div>
								</template>
							</el-table-column>
							<el-table-column label="套餐名称" min-width="140" prop="servicePackageName">
							</el-table-column>
							<el-table-column label="计划名称" min-width="100" prop="planName">
							</el-table-column>
							<el-table-column label="实施计划" min-width="70" prop="planName">
								<template slot-scope="props">
									<div>
										<span>{{props.row.planIndex}}</span>/<span>{{props.row.planCount}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="计划时间" min-width="90">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.planDate,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="添加人" min-width="70" prop="createUserName">
							</el-table-column>
							<el-table-column label="支付状态" min-width="70">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="是否出库" min-width="70">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isOut">已出库</div>
									<div style="color:#B7B7B7" v-if="props.row.isOut=== false">未出库</div>
								</template>
							</el-table-column>
							<el-table-column label="创建门店" min-min-width="70">
								<template slot-scope="props">
									<span v-if="props.row.shopId">{{$public.getShopNameById(props.row.shopId)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="执行门店" min-width="70">
								<template slot-scope="props">
									<span v-if="props.row.currShopId">{{$public.getShopNameById(props.row.currShopId)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="50">
							</el-table-column>
							<el-table-column label="操作" min-width="90">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toEdit(props.row)" v-if="props.row.isPay">出库</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				shopsList: [],
				search:{
					keyword:'',
					serviceTypeId:0,
					isPay:-1,
					isEnter:0,
					shopId:this.$store.state.shopId,
				},
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			yaofangParams(){
				return this.$store.state.yiliaoxin.yaofangParams;
			},
		},
		created(){
			this.page.page = Number(sessionStorage.getItem('ymqcPage'))||1
		},
		mounted(){
			let shopsList = JSON.parse(JSON.stringify(this.$store.getters['shopList']));
			if(shopsList[0]&&shopsList[0].shop_name!=='全部'){
				shopsList.unshift({shop_id:'',shop_name:'全部'})
			}
			this.shopsList = shopsList;
			
			this.search = this.yaofangParams.initialDataOflist_ymqc.search||this.search;
			this.page = this.yaofangParams.initialDataOflist_ymqc.page||this.page;
			this.getTableData();
		},
		methods: {
			toEdit(row){
				this.yaofangParams.curRow = row
				this.yaofangParams.type = 'edit'
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.$store.commit("yiliaoxin/add_router",{name:'药房',data:this.yaofangParams})
			},
			toSee(row){
				this.yaofangParams.curRow = row
				this.yaofangParams.type = 'see'
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.$store.commit("yiliaoxin/add_router",{name:'药房',data:this.yaofangParams})
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变筛选条件
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				sessionStorage.setItem('ymqcPage',num)
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"serviceTypeId": this.search.serviceTypeId,  // 1疫苗；2驱虫; Default:0 
					"isPay": this.search.isPay,          // -1 全部；0未支付；1已支付
					"petType": "",       //  猫类；犬类
					"status": 0,         // 1未完成；2已完成
					"isOut": this.search.isEnter,        // 是否录入     0 1 2
					"hasGoods":true,
					"desc": true,
					"shopId":this.search.shopId,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": this.search.keyword,
				}
				let loading=this.$loading();
				this.$http.post('/api/MedicalPackage/Plan/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
            console.log(res.data.data,'返回的数据');
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.yaofangParams.initialDataOflist_ymqc = {
					search:this.search,
					page:this.page,
				}
				this.$store.commit("yiliaoxin/set_yaofangParams",JSON.parse(JSON.stringify(this.yaofangParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'药房',data:JSON.parse(JSON.stringify(this.yaofangParams))})
			},
		},
		// beforeDestroy(){
		// 	this.yaofangParams.initialDataOflist_ymqc = {
		// 		search:this.search,
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_yaofangParams",JSON.parse(JSON.stringify(this.yaofangParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: 100%;box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 60px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
